import ArrowLeftIcon from '@mui/icons-material/ArrowLeft'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'
import { Box, IconButton, Typography } from '@mui/material'

import { isNullorEmpty, isNullorEmptyArr } from '@/utils'

import PieChart from './PieChart'

type DentinRecipePieChartType = {
  handleDentinIndexChange: (e: any, value: number) => void
  dentinIndex: number
  data: Record<string, any>
  isSingleOnCanvas?: boolean
  showBrand?: boolean
}

function DentinRecipePieChart(props: DentinRecipePieChartType) {
  const { handleDentinIndexChange, dentinIndex, data, isSingleOnCanvas } = props

  const isRecipeLayer1Empty = () => {
    return isNullorEmptyArr(
      [data, 'recipe_layer1', `${dentinIndex}`, 'powders'],
      [data, 'recipe_layer1', `${dentinIndex}`, 'simplified_ratios'],
    )
  }

  const isRecipeLayer2Empty = () => {
    return isNullorEmptyArr(
      [data, 'recipe_layer2', `${dentinIndex}`, 'powders'],
      [data, 'recipe_layer2', `${dentinIndex}`, 'simplified_ratios'],
    )
  }

  const maxIndex =
    Math.max(
      data?.recipe_layer1?.length ?? 0,
      data?.recipe_layer2?.length ?? 0,
    ) - 1

  return (
    <>
      {!(dentinIndex === 0 && dentinIndex === maxIndex) && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent={'space-between'}
        >
          <IconButton
            size="small"
            disabled={dentinIndex === 0}
            onClick={(e) => handleDentinIndexChange(e, dentinIndex - 1)}
            sx={{
              p: 0,
              width: 28,
              height: 28,
            }}
          >
            <ArrowLeftIcon
              sx={{
                fontSize: '26px',
                color: dentinIndex !== 0 ? '#90CAF9' : 'gray',
              }}
            />
          </IconButton>
          <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
            {dentinIndex + 1}/{maxIndex + 1}
          </Typography>
          <IconButton
            size="small"
            disabled={dentinIndex === maxIndex}
            onClick={(e) => handleDentinIndexChange(e, dentinIndex + 1)}
            sx={{
              p: 0,
              width: 28,
              height: 28,
            }}
          >
            <ArrowRightIcon
              sx={{
                fontSize: '26px',
                color: dentinIndex !== maxIndex ? '#90CAF9' : 'gray',
              }}
            />
          </IconButton>
        </Box>
      )}

      <Box display="flex" justifyContent="center" gap={1}>
        {isRecipeLayer1Empty() && (
          <Box
            width={isSingleOnCanvas ? '100%' : '50%'}
            px={1}
            textAlign="center"
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: '4px',
              }}
            >
              {isNullorEmpty(
                data,
                'recipe_layer1',
                `${dentinIndex}`,
                'opacity_category',
              ) && (
                <Typography
                  variant="body2"
                  sx={{
                    textTransform: 'capitalize',
                    bgcolor: 'rgba(33, 33, 33, 0.80)',
                    fontSize: '12px',
                    lineHeight: '20px',
                    letterSpacing: '0.25px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {data.recipe_layer1[dentinIndex].opacity_category}
                </Typography>
              )}
            </Box>
            <PieChart
              labels={data?.recipe_layer1[dentinIndex].powders}
              values={data?.recipe_layer1[dentinIndex].simplified_ratios}
              height={'78px'}
              width={'78px'}
            />
          </Box>
        )}

        {isRecipeLayer2Empty() && (
          <Box width="50%" px={1} textAlign="center">
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: '4px',
              }}
            >
              {isNullorEmpty(
                data,
                'recipe_layer2',
                `${dentinIndex}`,
                'opacity_category',
              ) && (
                <Typography
                  variant="body2"
                  sx={{
                    textTransform: 'capitalize',
                    bgcolor: 'rgba(33, 33, 33, 0.80)',
                    fontSize: '12px',
                    lineHeight: '20px',
                    letterSpacing: '0.25px',
                    padding: '2px 6px',
                    borderRadius: '4px',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {data.recipe_layer2[dentinIndex].opacity_category}
                </Typography>
              )}
            </Box>
            <PieChart
              labels={data?.recipe_layer2[dentinIndex].powders}
              values={data?.recipe_layer2[dentinIndex].simplified_ratios}
              height={'78px'}
              width={'78px'}
            />
          </Box>
        )}
      </Box>
    </>
  )
}

export default DentinRecipePieChart
